export default __webpack_public_path__ + "static/media/icon-submitted-success.dfc35ecf.svg";